import { captureMessage } from '@sentry/browser';
import React from 'react';
import { Link } from 'react-router-dom';
import { ITranslateProps, translate } from '../mixins/translate';

export interface INotFoundProps extends ITranslateProps {
    value?: string;
}

class NotFoundComponent extends React.Component<INotFoundProps, Record<string, unknown>> {
    public override componentDidMount() {
        captureMessage(`404: ${window.location.pathname}`, 'warning');
    }

    public override render() {
        return (
            <div className="center-block mt50 mw800">
                <h1 className="error-title">{this.props.t('common.routeNotFound')} </h1>
                <h2 className="error-subtitle">
                    <Link to="/surveys"> {this.props.t('common.goToDefaultPage')} </Link>{' '}
                </h2>
            </div>
        );
    }
}

// eslint-disable-next-line @typescript-eslint/naming-convention
const NotFound = translate()(NotFoundComponent);
export { NotFound };
